module.exports = __webpack_public_path__ + "static/media/img163.1f7b72cc.jpg";